export default __webpack_public_path__ + "static/media/5.16f3da44.JPG";